import React from 'react';
import { useState, useEffect } from 'react';
import Api from '../../services/api';
import { useHistory, Link } from 'react-router-dom';
import logoHorizontal from '../../assets/logohocohorizontal.png';
import backgroundMenu from '../../assets/backgroundMenu.jpg';
import { getPerfil, getData, logout } from '../../services/auth';
import {
  MDBNavbar,
  MDBNavbarNav,
  MDBNavItem,
  MDBModal,
  MDBModalHeader,
  MDBModalBody,
  MDBRow,
  MDBCol,
  MDBBtn,
  MDBModalFooter,
  MDBDropdown,
  MDBDropdownToggle,
  MDBDropdownMenu,
  MDBDropdownItem,
  MDBIcon,
  MDBSideNavCat,
  MDBSideNavNav,
  MDBSideNav,
  MDBContainer,
  MDBSideNavLink,
} from 'mdbreact';

import api from '../../services/api';
export default function NavBar(props) {
  const [alertas, setAlertas] = useState([]);
  const [toggleStateA, setToggleStateA] = useState(false);
  const [breakWidth, setBreakWidth] = useState(1300);
  const [windowWidth, setWindowWidth] = useState(0);
  const [modulos, seModulos] = useState([]);
  const history = useHistory();
  const [isOpen, setIsOpen] = useState(false);
  // visibilidade controlada da barra lateral (toggle real abrir/ocultar).
  // comeca aberta em telas largas (comportamento atual) e fechada em telas
  // estreitas; o botao "bars" alterna.
  const [sidebarAberta, setSidebarAberta] = useState(
    window.innerWidth > 1300
  );
  const handleResize = () => setWindowWidth(window.innerWidth);
  const handleToggleClickA = () => {
    setToggleStateA(!toggleStateA); // mantem o trigger interno do MDBSideNav
    setSidebarAberta(prev => !prev); // controla a visibilidade real
  };
  const buscaAlertas = async () => {
    const result = await api.get('/alertas');

    setAlertas(result.data);
  };

  useEffect(() => {
    buscaAlertas();
  }, []);
  const acesso = async () => {
    try {
      const response = await Api.get('/card-acesso');
      const teste = window.location.pathname.split('/');

      seModulos(response.data);
    } catch (error) {
      logout();
      // this.props.history.push('/app');
    }
  };

  // Título da tela na própria barra: quem chega aqui por três toques (e parte
  // do efetivo tem pouca familiaridade com o sistema) perde a referência assim
  // que rola a página e o título do corpo sai de vista. O nome sai do mesmo
  // /card-acesso que monta o menu lateral — nenhuma tela precisa passar prop.
  const tituloDaTela = (() => {
    const caminhoAtual = window.location.pathname;
    let achado = null;
    (modulos || []).forEach(gerenciaModulo => {
      const mod = gerenciaModulo.modulo || {};
      (mod.funcionalidades || []).forEach(func => {
        if (!func.rota || func.rota === '/app') return;
        // casa a rota exata e também as com parâmetro (/abordagem/:id)
        const casa =
          caminhoAtual === func.rota ||
          caminhoAtual.indexOf(`${func.rota}/`) === 0;
        if (casa && (!achado || func.rota.length > achado.rota.length)) {
          achado = { rota: func.rota, nome: func.nome, modulo: mod.titulo };
        }
      });
    });
    return achado;
  })();

  // padding do conteudo so existe quando a barra esta aberta em tela larga
  const barraVisivelDesktop = windowWidth > breakWidth && sidebarAberta;

  const navStyle = {
    // header fica ACIMA da barra lateral (z-index na regra .navbar), entao o
    // botao pode ficar sempre no canto esquerdo (padding fixo), visivel mesmo
    // com a barra aberta cobrindo o topo dela.
    paddingLeft: '16px',
    transition: 'padding-left 0.3s',
  };

  const mainStyle = {
    // margin: '0 6%',
    margin: '0 1%',
    paddingTop: '5.5rem',
    paddingLeft: barraVisivelDesktop ? '210px' : '0',
    transition: 'padding-left 0.3s',
  };

  const specialCaseNavbarStyles = {
    WebkitBoxOrient: 'horizontal',
    flexDirection: 'row',
  };

  const sair = () => {
    logout();
    history.push('/');

    // return <Redirect to={'/app'} />;
  };

  useEffect(() => {
    handleResize();
    acesso();
    window.addEventListener('resize', () => handleResize());

    return window.removeEventListener('resize', () => handleResize());
  }, []);

  // Arrastar o menu lateral no celular rolava a PÁGINA por baixo: o overlay do
  // MDBSideNav intercepta o clique, mas não trava o scroll do documento, então
  // o gesto vazava para o conteúdo. Só travamos quando a barra está SOBREPOSTA
  // (tela estreita) — no desktop ela divide a largura com o conteúdo e a página
  // continua rolando normalmente. innerWidth é lido aqui, e não no render, para
  // não depender de um estado que começa em 0.
  useEffect(() => {
    const sobreposta = sidebarAberta && window.innerWidth <= breakWidth;
    const anterior = document.body.style.overflow;
    document.body.style.overflow = sobreposta ? 'hidden' : anterior || '';

    return () => {
      document.body.style.overflow = '';
    };
  }, [sidebarAberta, breakWidth]);

  return (
    <div
      className={`fixed-sn white-skin ${
        sidebarAberta ? '' : 'sidebar-oculta'
      }`}
    >
      {/* O MDBSideNav sobrescreve style/className proprios, entao escondemos a
          barra por CSS mirando o .side-nav filho (transform fica NO proprio
          elemento fixed, sem quebrar o position:fixed). */}
      <style>{`
        .fixed-sn.sidebar-oculta .side-nav {
          transform: translateX(-110%) !important;
        }
        /* A barra lateral comeca ABAIXO do header (faixa do topo ~64px),
           nunca atras dele -> o logo aparece inteiro. height ajustada para
           nao estourar a viewport. */
        .fixed-sn .side-nav {
          top: 64px !important;
          height: calc(100% - 64px) !important;
          transition: transform 0.3s ease !important;
        }
        /* header acima da barra (so por seguranca; com o top:64px elas nem
           se sobrepoem mais) */
        .fixed-sn .navbar {
          z-index: 1045 !important;
        }
        .fixed-sn .side-nav {
          z-index: 1030 !important;
        }
        /* O menu vinha em 0,8rem (~12,8px) para o módulo e menor ainda para o
           atalho — o mesmo defeito de tamanho que a home tinha. Aqui há largura
           de sobra (a barra tem 240px), então o texto sobe para 15px/14px sem
           quebrar nada. Precisa ser CSS: o MDBSideNavCat/Link não aceita style
           no elemento que de fato renderiza o texto. */
        .fixed-sn .side-nav .collapsible > li > a {
          font-size: 15px !important;
          font-weight: 500;
        }
        .fixed-sn .side-nav .collapsible-body a {
          font-size: 14px !important;
        }
        /* Alvo de toque: 44px é o piso recomendado para o dedo. A altura tem de
           ser MÍNIMA e não fixa — o MDB fixa height/line-height, e com o texto
           maior "Gestão de Ocorrências" passou a ocupar duas linhas e invadir o
           item de baixo. */
        .fixed-sn .side-nav .collapsible a {
          min-height: 44px;
          height: auto !important;
          line-height: 1.3 !important;
          padding-top: 10px;
          padding-bottom: 10px;
          display: flex;
          align-items: center;
        }
      `}</style>
      <MDBSideNav
        triggerOpening={toggleStateA}
        // #91: fechar clicando no overlay sincroniza a visibilidade do app com
        // o fechamento interno do MDBSideNav (sem tocar em toggleStateA, que
        // re-dispararia o triggerOpening). Sem isso os dois estados
        // desincronizavam e o próximo toggle mostrava só o overlay, sem o menu.
        onOverlayClick={() => setSidebarAberta(false)}
        breakWidth={breakWidth}
        bg={backgroundMenu}
        mask="strong"
        fixed
      >
        <div className="my-3 w-100 d-flex justify-content-center  d-print-none">
          <Link to="/app" className="w-100 h-100">
            <img
              src={logoHorizontal}
              alt="Logo"
              style={{
                width: '190px',

                borderRadius: '5px',
              }}
            />
          </Link>
        </div>

        <br />
        <div className="d-flex justify-content-center blue-grey-text font-weight-bolder">
          Olá, {getPerfil().nome}
        </div>
        <MDBSideNavNav>
          {modulos.map(moduloMenu => (
            <MDBSideNavCat
              key={moduloMenu.id}
              name={moduloMenu.modulo.titulo}
              id="submit-blog-cat"
              icon="chevron-right"
            >
              {moduloMenu.modulo.funcionalidades.map(func => (
                <MDBSideNavLink key={func.id} to={func.rota}>
                  {func.nome}
                </MDBSideNavLink>
              ))}
            </MDBSideNavCat>
          ))}
        </MDBSideNavNav>
      </MDBSideNav>

      <MDBNavbar
        className="p-2 d-print-none"
        style={navStyle}
        double
        expand="md"
        fixed="top"
        // scrolling
      >
        {/* flex-row explícito: abaixo do breakpoint o MDBNavbarNav vira
            coluna e empilhava menu, logo e título, engordando a barra */}
        <MDBNavbarNav left className="flex-row align-items-center">
          <MDBNavItem>
            <div
              onClick={handleToggleClickA}
              key="sideNavToggleA"
              // o bloco escuro de 2x pesava muito mais que o sino e o
              // usuário do outro lado; aqui ele passa a ter o mesmo peso deles
              style={{
                cursor: 'pointer',
                borderRadius: '6px',
                padding: '8px 10px',
                marginRight: '0.5em',
                display: 'flex',
                alignItems: 'center',
                color: 'rgba(0,0,0,0.7)',
              }}
              title="Abrir o menu"
            >
              <MDBIcon icon="bars" size="lg" />
            </div>
          </MDBNavItem>

          {/* a logo sumia no celular (d-none d-md-flex): além da identidade,
              perdia-se o atalho de voltar ao início tocando na marca */}
          {window.innerWidth > 1300 ? (
            ''
          ) : (
            <MDBNavItem className="d-flex align-items-center" to="/app">
              <Link to="/app" title="Ir para o início">
                <img
                  className="d-none d-sm-inline"
                  style={{ width: '120px' }}
                  src={logoHorizontal}
                  alt="Operação Foco"
                />
                <img
                  className="d-inline d-sm-none"
                  style={{ width: '86px' }}
                  src={logoHorizontal}
                  alt="Operação Foco"
                />
              </Link>
            </MDBNavItem>
          )}

          {tituloDaTela && (
            <MDBNavItem className="d-flex align-items-center ml-2 ml-md-3">
              <span
                className="text-truncate"
                style={{
                  color: 'rgba(0,0,0,0.7)',
                  fontWeight: 500,
                  maxWidth: '42vw',
                  lineHeight: 1.2,
                }}
                title={`${tituloDaTela.modulo} · ${tituloDaTela.nome}`}
              >
                <span className="d-none d-md-inline" style={{ opacity: 0.6 }}>
                  {tituloDaTela.modulo} ·{' '}
                </span>
                {tituloDaTela.nome}
              </span>
            </MDBNavItem>
          )}
        </MDBNavbarNav>

        {props.btn && props.btn}
        <MDBNavbarNav right style={specialCaseNavbarStyles}>
          {/* <MDBNavItem>
            <MDBNavLink to="#!" link>
              <MDBIcon
                style={{ fontSize: '12px' }}
                icon="comments"
                className="d-inline-inline"
              />{' '}
              <div style={{ fontSize: '12px' }} className="d-none d-md-inline">
                Suporte
              </div>
            </MDBNavLink>
          </MDBNavItem>
          <MDBNavItem>
            <MDBNavLink to="#!" link>
              <MDBIcon
                style={{ fontSize: '12px' }}
                icon="university"
                className="d-inline-inline"
              />{' '}
              <div style={{ fontSize: '12px' }} className="d-none d-md-inline">
                Tutorial
              </div>
            </MDBNavLink>
          </MDBNavItem> */}
          <MDBNavItem
            onClick={() => setIsOpen(true)}
            className="d-flex align-items-center mr-3 cursor-pointer"
            style={{ position: 'relative' }}
          >
            <MDBIcon far icon="bell" style={{ fontSize: '20px' }} />
            {alertas.length > 0 && (
              <span
                style={{
                  position: 'absolute',
                  top: '30px',
                  right: '20px',
                  transform: 'translate(50%, -50%)',
                  backgroundColor: 'red',
                  color: 'white',
                  borderRadius: '50%',
                  padding: '0.25em 0.5em',
                  fontSize: '0.75em',
                  fontWeight: 'bold',
                }}
              >
                {alertas.length}
              </span>
            )}
          </MDBNavItem>

          <MDBNavItem>
            <MDBDropdown>
              <MDBDropdownToggle nav caret>
                <MDBIcon icon="user" style={{ width: '20px' }} />
              </MDBDropdownToggle>

              <MDBDropdownMenu right>
                <MDBDropdownItem onClick={() => history.push('/meu-perfil')}>
                  Meu Perfil
                </MDBDropdownItem>
                <MDBDropdownItem
                  onClick={() => {
                    sair();
                  }}
                >
                  Sair
                </MDBDropdownItem>
              </MDBDropdownMenu>
            </MDBDropdown>
          </MDBNavItem>
        </MDBNavbarNav>
      </MDBNavbar>
      <main className="d-flex justify-content-center" style={mainStyle}>
        <MDBContainer className="m-0">{props.children}</MDBContainer>
      </main>
      <MDBModal
        overflowScroll
        isOpen={isOpen}
        toggle={() => setIsOpen(false)}
        size="lg"
      >
        <MDBModalHeader
          className=" font-weight-bold"
          toggle={() => setIsOpen(false)}
        >
          Meus Alertas
        </MDBModalHeader>
        <MDBModalBody>
          <MDBContainer>
            {alertas && alertas.length === 0 ? (
              <MDBRow>
                <MDBCol className="green-text h3 text-center">
                  Parabéns você não tem alertas
                </MDBCol>
              </MDBRow>
            ) : (
              <MDBRow
                center
                className="text-danger h5-responsive font-weight-bold mb-5"
              >
                Atenção, os alertas somente serão excluidos quando o sistema
                detectar que o erro foi sanado.
              </MDBRow>
            )}
            {alertas &&
              alertas.length > 0 &&
              alertas.map(alertas => (
                <MDBRow className="p-3 font-weight-bolder border-top ">
                  <MDBCol middle size="12" md="6">
                    {alertas.texto}
                  </MDBCol>
                  {alertas.link && (
                    <MDBCol
                      size="12"
                      md="6"
                      className="d-flex justify-content-center justify-content-md-end "
                    >
                      <Link
                        to={alertas.link}
                        onClick={() => setIsOpen(false)}
                        className="d-flex flex-column align-items-center btn btn-sm font-weight-bold"
                        style={{
                          color: 'rgba(0,0,0,0.6)',
                          maxWidth: '120px',
                        }}
                      >
                        ABRIR
                      </Link>
                    </MDBCol>
                  )}
                </MDBRow>
              ))}
          </MDBContainer>
        </MDBModalBody>
        <MDBModalFooter>
          <MDBBtn color="danger" size="sm" onClick={() => setIsOpen(false)}>
            Fechar
          </MDBBtn>
        </MDBModalFooter>
      </MDBModal>
    </div>
  );
}
